import { postDeals } from '@general/api/shared';

export const postChatUsers = graphID =>
    postDeals({
        endpoint: `chat-users`,
        data: {
            identity: graphID,
        },
    });

// Checks if member is a Twilio user, if not, BE creates it
const chatUserEnsure = async graphID => {
    try {
        const res = await postChatUsers(graphID);
        return res.data.data;
    } catch (e) {
        console.log(e);
    }
};

export default chatUserEnsure;
